import { setLoadingState, resetLoadingState } from '../../utils/common.js';

export function initClientFilters() {
    // Filter Drawer Toggle
    $('.btn-open-filters').on('click', function () {
        $('#filtersDrawer').addClass('open');
        $('#filtersDrawerBackdrop').addClass('show');
        $('body').addClass('overflow-hidden');
    });

    $('.btn-close-filters, #filtersDrawerBackdrop').on('click', function () {
        $('#filtersDrawer').removeClass('open');
        $('#filtersDrawerBackdrop').removeClass('show');
        $('body').removeClass('overflow-hidden');
    });

    // Clear individual filters
    $('.clear-select').on('click', function () {
        const target = $(this).data('target');
        $(`select[name="${target}"]`).val('').trigger('change');
    });

    $('.clear-field').on('click', function () {
        const target = $(this).data('target');
        $(`input[name="${target}"]`).val('');
    });

    // Clear all filters
    $('#btnClearAllFilters').on('click', function () {
        $('#clientsFiltersForm select').val('').trigger('change');
        $('#filterCount').text('0').addClass('d-none');
        console.log('Client Filters Cleared'); // Debug log
        applyFilters();
    });

    // Clear filters from No Data state
    $(document).on('click', '#btnClearFiltersNoData', function () {
        $('#btnClearAllFilters').trigger('click');
    });

    // Apply Filters
    function applyFilters() {
        const btn = $('#btnApplyFilters');
        // Only set loading state if triggered by button click
        if (btn.length && btn.is(':focus')) {
            setLoadingState(btn, 'Aplicando...');
        }

        const filters = {
            tipo_cliente: $('#tipoCliente').val(),
            uf: $('#ufFilter').val(),
            cidade: $('#cidadeFilter').val(),
            order_by: $('#orderBySelect').val()
        };

        // Update active filters count (excluding sort)
        let activeCount = 0;
        if (filters.tipo_cliente) activeCount++;
        if (filters.uf) activeCount++;
        if (filters.cidade) activeCount++;

        console.log('Client Active Count:', activeCount); // Debug log
        const $badge = $('#filterCount');
        if ($badge.length) {
            if (activeCount > 0) {
                $badge.text(activeCount).removeClass('d-none');
            } else {
                $badge.text('0').addClass('d-none');
            }
        }

        // Trigger the unified search logic via event
        $(document).trigger('search:refresh');

        // Reset button state and close drawer
        if (btn.length) resetLoadingState(btn);

        // Close drawer if open
        if ($('#filtersDrawer').hasClass('open')) {
            $('.btn-close-filters').trigger('click');
        }
    }

    $('#btnApplyFilters').on('click', applyFilters);

    // Order By Change
    $(".js-sort-option").on("click", function (e) {
        e.preventDefault();

        // Remove active class from all options and add to clicked one
        $(".js-sort-option").removeClass("active");
        $(this).addClass("active");

        // Update hidden input value
        const value = $(this).data("value");
        $("#orderBySelect").val(value);

        applyFilters();
    });
    $('#exportSelectedXls').on('click', function (e) {
        e.preventDefault();

        const selectedIds = [];
        $('.client-checkbox:checked').each(function () {
            selectedIds.push($(this).val());
        });

        if (selectedIds.length === 0) {
            const message = 'Selecione pelo menos um cliente.';

            // Prioriza o modal padrão de erro com ícone (Bootstrap)
            if (window.bootstrap && typeof window.bootstrap.Modal !== 'undefined') {
                let modalEl = document.getElementById('errorModal');
                if (!modalEl) {
                    modalEl = document.createElement('div');
                    modalEl.id = 'errorModal';
                    modalEl.className = 'modal fade';
                    modalEl.setAttribute('tabindex', '-1');
                    modalEl.setAttribute('aria-modal', 'true');
                    modalEl.setAttribute('role', 'dialog');
                    modalEl.innerHTML = `
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-body text-center">
                                    <span class="icon-bg-lg m-auto mb-3"><i class="sg sg-smiley-x-eyes"></i></span>
                                    <div id="errorModalMessages" class="mb-3"></div>
                                    <div class="text-center d-flex justify-content-center">
                                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Fechar</button>
                                    </div>
                                </div>
                            </div>
                        </div>`;
                    document.body.appendChild(modalEl);
                }

                const messagesEl = modalEl.querySelector('#errorModalMessages');
                if (messagesEl) {
                    messagesEl.innerHTML = `<p class="mb-0">${message}</p>`;
                }

                const modal = new window.bootstrap.Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false,
                });
                modal.show();
                return;
            }

            // Fallback
            alert(message);
            return;
        }

        const filters = {
            tipo_cliente: $('#tipoCliente').val(),
            uf: $('#ufFilter').val(),
            cidade: $('#cidadeFilter').val(),
            order_by: $('#orderBySelect').val(),
            selected_ids: selectedIds.join(',')
        };

        // Build query string
        const queryString = new URLSearchParams(filters).toString();
        window.location.href = `/clientes/export?${queryString}`;
    });

    // Selection Logic
    // Select All
    $('#selectAllClients').on('change', function () {
        const isChecked = $(this).is(':checked');
        $('.client-checkbox').prop('checked', isChecked);
        updateSelectionToolbar();
    });

    // Individual Checkbox
    $(document).on('change', '.client-checkbox', function () {
        updateSelectionToolbar();

        // Update "Select All" state
        const allChecked = $('.client-checkbox:not(:checked)').length === 0;
        $('#selectAllClients').prop('checked', allChecked);
    });

    // Clear Selection
    $('#clearSelectionLink').on('click', function (e) {
        e.preventDefault();
        $('.client-checkbox').prop('checked', false);
        $('#selectAllClients').prop('checked', false);
        updateSelectionToolbar();
    });

    $('#btnSelectAll').on('click', function () {
        const checkbox = $('#selectAllClients');
        checkbox.prop('checked', !checkbox.is(':checked')).trigger('change');
    });

    function updateSelectionToolbar() {
        const selectedCount = $('.client-checkbox:checked').length;
        $('#selectedCount').text(selectedCount);

        if (selectedCount > 0) {
            $('#selectionToolbar').removeClass('d-none');
        } else {
            $('#selectionToolbar').addClass('d-none');
        }
    }
}
